import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FatigueReporting = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Fatigue Reporting</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.enableNonPunitiveReporting}
                  onChange={(e) => handleChange('enableNonPunitiveReporting', e.target.checked)}
                />
              }
              label="Enable Non-Punitive Reporting (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.requireQuarterlyReport}
                  onChange={(e) => handleChange('requireQuarterlyReport', e.target.checked)}
                />
              }
              label="Require Quarterly Report (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Fatigue Report Retention (Months)"
              type="number"
              value={baseline.fatigueReportRetentionMonths}
              onChange={(e) => handleChange('fatigueReportRetentionMonths', parseInt(e.target.value))}
              inputProps={{ min: 6, max: 60 }}
              helperText="CAR Section 7, Series J - Retention period"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FatigueReporting;
